<template>
  <div
    class="w-full overflow-auto bg-auth-canvas px-3 text-auth-text dark:bg-auth-canvas-dark dark:text-auth-text-dark sm:px-5 lg:px-6"
  >
    <div class="mx-auto w-full max-w-7xl pb-12">
      <router-view />
    </div>
  </div>
</template>
